<div class="screen">
  <div class="screen-inner">
    <app-shell nav="back" title="Payouts" [backTo]="backTo"></app-shell>

    @if (dashboard) {
      <p class="section-label">Collected {{ pot }} · paid out {{ paidOut }} · left {{ pot - paidOut }}</p>

      @if (dashboard.payouts.length === 0) {
        <p class="page-note">No payouts recorded.</p>
      } @else {
        <div class="card">
          @for (payout of dashboard.payouts; track payout.id) {
            <div class="row row-static">
              <span class="row-body">
                <span class="row-title">{{ label(payout) }}</span>
                <span class="row-meta">{{ winner(payout) }} · {{ payout.amount }}</span>
              </span>
              <button class="btn-quiet btn-danger" type="button" [disabled]="busy" (click)="remove(payout.id)">Remove</button>
            </div>
          }
        </div>
      }

      <button class="btn-primary" type="button" (click)="add()">Add payout</button>
    }

    @if (error) { <p class="error">{{ error }}</p> }
  </div>
</div>
